export const CountrySelectStyle = {
  option: (provided: any, state: { isSelected: any; isFocused: any }) => ({
    ...provided,
    whiteSpace: "normal",
    wordBreak: "break-word",
    padding: 10,
    backgroundColor: state.isSelected
      ? "#00989E"
      : state.isFocused
      ? "#FFFFFF"
      : "#FFFFFF",
    color: state.isSelected ? "#ffffff" : "#333333",
    marginBottom: "2px",
    zIndex: "10",
    display: "flex",
    alignItems: "center",
    width: "100%",
    svg: {
      width: "25px",
      height: "25px",
      marginRight: "10px",
    },
    "&:hover": {
      backgroundColor: "rgb(0 136 141 / 20%)",
      color: "#00989E",
    },
  }),
  control: (provided: any, state: { isDisabled: boolean }) => ({
    ...provided,
    whiteSpace: "normal",
    wordBreak: "break-word",
    width: "120px",
    marginRight: "5px",
    minHeight: "58px",
    display: "flex",
    alignItems: "center",
    borderRadius: "13px",
    borderColor: state.isDisabled ? "#cccccc" : "#cccccc",
    backgroundColor: state.isDisabled ? "#e9ecef" : "#ffffff",
    boxShadow: "none",
    svg: {
      width: "25px",
      height: "25px",
      marginRight: "10px",
    },
    "&:hover": {
      borderColor: "#00989E",
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    width: "100%",
    marginTop: "2px",
    marginBottom: "2px",
    zIndex: 9999,
    position: "absolute",
    left: 0,
    right: 0,
    boxShadow: "0 1px 6px rgba(0, 0, 0, 0.1)",
    backgroundColor: "white",
    overflow: "hidden",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    svg: {
      width: "25px",
      height: "25px",
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: "0 0 0 10px",
    width: "100px",
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    padding: "0 !important",
    alignItems: "center",
    display: "flex",
    width: "30px",
    justifyContent: "center",
    span: {
      display: "none",
    },
    svg: {
      width: "25px !important",
      height: "25px !important",
      marginRight: "0px !important",
    },
  }),
};
